var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#1A3D82",
    d: "m7.52016,6.05694l0,-0.9143c0,-1.00993 0.80227,-1.82865 1.79193,-1.82865l5.37582,0c0.98967,0 1.79193,0.81872 1.79193,1.82865l0,0.9143l2.68791,0c0.49483,0 0.89598,0.40936 0.89598,0.91432c0,0.50497 -0.40114,0.91432 -0.89598,0.91432l-0.89596,0l0,10.05747c0,1.5149 -1.20343,2.74295 -2.68791,2.74295l-7.16777,0c-1.48448,0 -2.68791,-1.22805 -2.68791,-2.74295l0,-10.05747l-0.89596,0c-0.49483,0 -0.89598,-0.40936 -0.89598,-0.91432c0,-0.50497 0.40114,-0.91432 0.89598,-0.91432l2.68791,0zm1.79193,-0.9143l5.37582,0l0,0.9143l-5.37582,0l0,-0.9143zm-1.79193,2.74295l8.95968,0l0,10.05747c0,0.50497 -0.40112,0.91432 -0.89596,0.91432l-7.16777,0c-0.49481,0 -0.89596,-0.40936 -0.89596,-0.91432l0,-10.05747z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#1A3D82",
    d: "m14.68791,9.71421l-1.79193,0l0,7.31452l1.79193,0l0,-7.31452z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#1A3D82",
    d: "m11.10402,9.71421l-1.79193,0l0,7.31452l1.79193,0l0,-7.31452z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.84d7d2d0ce2be97cbdb9e1a943caa2a2.svg";
export { ForwardRef as ReactComponent };